import React, {useState, useMemo, useEffect, useRef} from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';
import Container from 'components/layout/Container';
import {Link} from 'react-router-dom';
import ArrowDown from 'components/ui/icon/ArrowDown';
import ArrowRight from 'components/ui/icon/ArrowRight';

import './FAQ.scss';

const DATA = [
  {
    question: <>Сколько времени занимает ремонт?</>,
    answer: (
      <>
        Косметический ремонт может занимать от&nbsp;3&nbsp;до&nbsp;7&nbsp;дней,
        при более сложных видах работ процесс может занимать большее количество
        времени. Срок работ зависит от&nbsp;типа ремонта, необходимости
        перепланировок, которые требуют оформления, выбранных материалов
        отделки.
      </>
    ),
  },
  {
    question: <>Кто контролирует ход работ и&nbsp;качество?</>,
    answer: (
      <>
        Наш архитектор будет сопровождать и&nbsp;контролировать весь ход работ.
      </>
    ),
  },
  {
    question: <>Можно&nbsp;ли выполнить ремонт совмещенного санузла?</>,
    answer: (
      <>
        Да, подобные работы выполняются. Возможны как ремонт отдельно ванной
        комнаты и&nbsp;туалета, так и&nbsp;для совмещенного санузла. При
        необходимости, возможен демонтаж стены.
      </>
    ),
  },
  {
    question: (
      <>
        А&nbsp;вы&nbsp;занимаетесь только ванными комнатами или умеете что-то
        ещё?
      </>
    ),
    answer: (
      <>
        Сервис Руки с&nbsp;2017 года на&nbsp;рынке. Наши мастера выполняют весь
        спектр услуг мелкого бытового ремонта. Выбрать услугу можно
        на&nbsp;сайте <a href="https://hands.ru">Hands.ru</a>.
      </>
    ),
  },
  {
    question: <>Кто ваши мастера? Можно выбирать бригаду?</>,
    answer: (
      <>
        Мастера проходят строгий отбор. Только&nbsp;4% кандидатов
        мы&nbsp;допускам к&nbsp;работе. Предложим на&nbsp;выбор несколько
        бригад, а&nbsp;если выбранная бригада не&nbsp;устроит в&nbsp;процессе
        ремонта&nbsp;&mdash; заменим.
      </>
    ),
  },
  {
    question: <>Что включает дизайн-проект?</>,
    answer: (
      <>
        Все, начиная с&nbsp;плана электрики и&nbsp;заканчивая расстановкой
        мебели и&nbsp;материалами. <Link to="/documents">Подробнее</Link>.
      </>
    ),
  },
  {
    question: <>Можно обсудить с&nbsp;дизайнером мои предпочтения?</>,
    answer: (
      <>
        Каждый проект прорабатываем индивидуально с&nbsp;заказчиком.
        На&nbsp;встрече с&nbsp;архитектором вы&nbsp;сможете рассказать свои
        пожелания и&nbsp;задать необходимые вопросы.
      </>
    ),
  },
  {
    question: <>Сколько стоит дизайн-проект?</>,
    answer: (
      <>
        Стоимость проекта: 8000&nbsp;₽. Если ремонт делаете
        с&nbsp;нами&nbsp;&mdash; проект бесплатно!
      </>
    ),
  },
  {
    question: <>Вы&nbsp;помогаете с&nbsp;выбором и&nbsp;покупкой материалов?</>,
    answer: (
      <>
        Посоветуем лучшие материалы для отделки, ориентируясь на&nbsp;ваш
        бюджет. При желании купим по&nbsp;минимальной цене и&nbsp;доставим
        на&nbsp;объект собственными силами.
      </>
    ),
  },
  {
    question: <>Какие этапы ремонта?</>,
    answer: (
      <>
        1. Наш арихтектор выезжает к&nbsp;вам.
        <br />
        2. Делаем проект ремонта и&nbsp;расчёт стоимости с&nbsp;учетом ваших
        пожеланий.
        <br />
        3. Подбираем бригаду, подписываем договор.
        <br />
        4. Проводим ремонтные работы.
        <br />
        5. Делаем уборку и&nbsp;осуществляем приёмку работ.
      </>
    ),
  },
  {
    question: <>Можно жить в&nbsp;квартире, пока идёт ремонт?</>,
    answer: (
      <>
        Это ваше индивидуальное решение, но&nbsp;как правило, работы
        не&nbsp;мешают проживанию.
      </>
    ),
  },
  {
    question: <>Я&nbsp;дам мастерам ключи, это безопасно?</>,
    answer: (
      <>
        Это безопасно&nbsp;&mdash; все наши мастера прошли проверку.
        Но&nbsp;если вы&nbsp;захотите, после завершения работ мы&nbsp;поменяем
        личинку замка входной двери.
      </>
    ),
  },
  {
    question: <>Кто делает уборку после ремонта?</>,
    answer: (
      <>
        Уборка и&nbsp;вывоз строительного мусора включены в&nbsp;стоимость.
        Вы&nbsp;сможете принять ванну сразу после завершения всех работ!
      </>
    ),
  },
  {
    question: <>Есть гарантия на&nbsp;работы?</>,
    answer: <>Да, гарантия на&nbsp;все работы&nbsp;&mdash; 1&nbsp;год.</>,
  },
  {
    question: <>Как происходит оплата?</>,
    answer: (
      <>
        Каждый этап работ оплачивается отдельно после завершения. Оплата
        производится напрямую архитектору и бригаде.
      </>
    ),
  },
  {
    question: <>Будет официальный договор?</>,
    answer: <>Да, работаем по&nbsp;договору.</>,
  },
];

export default function FAQ() {
  const [isOpen, setIsOpen] = useState(false);

  const questionsAndAnwsers = useMemo(
    () => DATA.slice(0, isOpen ? DATA.length : 5),
    [isOpen],
  );

  return (
    <section className="faq">
      <Container extraClassName="faq__wrapper">
        <Title
          extraClassName="faq__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
        >
          Вопросы и&nbsp;ответы
        </Title>

        <div className="faq__list">
          {questionsAndAnwsers.map(questionAndAnswer => (
            <FAQItem
              key={questionAndAnswer.question.props.children}
              {...questionAndAnswer}
            />
          ))}

          {!isOpen && (
            <button className="faq__button" onClick={() => setIsOpen(true)}>
              БОЛЬШЕ ВОПРОСОВ
              <ArrowRight color="#00f" />
            </button>
          )}
        </div>
      </Container>
    </section>
  );
}

function FAQItem({question, answer}) {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const answerContainerRef = useRef(null);

  useEffect(() => {
    setHeight(isOpen ? answerContainerRef?.current?.scrollHeight || 0 : 0);
  }, [isOpen]);

  return (
    <div
      className={`faq__item faq__item--${isOpen ? 'open' : 'closed'}`}
      style={{gap: `${isOpen ? 16 : 0}px`}}
    >
      <div
        className="faq__item_question-container"
        onClick={() => {
          setIsOpen(prev => !prev);
        }}
      >
        <p className="faq__item_question">{question}</p>
        <ArrowDown extraClassName={'faq__item-icon'} />
      </div>

      <div
        className="faq__item_answer-container"
        style={{
          height: height,
          transition: 'height 0.3s ease',
        }}
        aria-hidden={!isOpen}
        ref={answerContainerRef}
      >
        <p className="faq__item_answer">{answer}</p>
      </div>
    </div>
  );
}
